/**
 * 修复子路由的path 将path更改为以 ‘/’ 开始的相对路径
 * @param list
 * @returns
 */
export function resetPathForRoute(list) {
  return list.map(route => {
    return {
      ...route,
      // path 若不以 ’/‘ 开头，需给予默认 ’/‘
      path: /^\/+/.test(route.path) ? route.path : `/${route.path}`
    };
  });
}
